import {FC} from 'react'
import {Link} from 'react-router-dom'
import {toAbsoluteUrl} from '../../../../_metronic/helpers'

const Error404: FC = () => {
  // Get user permissions
  const permissions = JSON.parse(localStorage.getItem('permissions') || '[]');
  
  // Find first permitted route
  const getFirstPermittedRoute = () => {
    const routeMap: { [key: string]: string } = {
      'Dashboard': '/dashboard',
      'Offers': '/offer-management/offers',
      'Offer With Price': '/offer-with-price',
      'Seller Messaging Module': '/seller-message-module',
      'Multiple Offer With Price': '/multiple-offer-with-price',
      'Inquiries': '/inquiry-management/inquiries',
      'Quotations': '/quotation-management/quotations',
      'Purchase orders': '/purchase-order/purchases',
      'Buyers': '/buyer-management/buyers',
      'Sellers': '/seller-management/sellers',
      'Grade Groups': '/grade-group-management/grades',
      'Product Groups': '/product-group-management/Products',
      'Products': '/product-management/products',
      'Locations': '/masters/locations',
      'Districts': '/masters/districts',
      'States': '/masters/states',
      'Roles': '/masters/roles',
      'Users': '/masters/users/users',
      'Copy Freights': '/copy-freight-management/freights',
      'Transporters': '/masters/transports/transports',
      'Usage Analysis': '/buyerseller-report/buyersellers',
      'Order Duration Analysis': '/order-report/orders',
      'Inquiry to Invoice Analysis': '/inquiry-report/inquirys',
      'Grade Group Wise Report': '/grade-group-report/gradegroups',
      'Near to Expiry Offers': '/near-expire-offer/expireoffers',
      'Active Inquiries': '/active-inquiry-report/activeinquiries',
      'Recently Completed Inquiries': '/complete-inquiry-report/completeinquiries',
      'User Wise Inquiry': '/userwise-inquiry-report/userinquiries',
      'Operation Report': '/operation-report/operation',
      'News Articles': '/news-articles/articles',
      'Category': '/news-category/cates',
      'Settings': '/setting'
    };

    for (const permission of permissions) {
      if (permission.actions?.some((a: any) => a.status === true) && routeMap[permission.name]) {
        return routeMap[permission.name];
      }
    }
    return '/dashboard'; // Default fallback
  };

  return (
    <>
      {/* begin::Title */}
      <h1 className='fw-bolder fs-2hx text-gray-900 mb-4'>Page Not Found</h1>
      {/* end::Title */}

      {/* begin::Text */}
      <div className='fw-semibold fs-6 text-gray-500 mb-7'>
        The page you are looking for doesn't exist or you don't have permission to access it.
      </div>
      {/* end::Text */}

      {/* begin::Illustration */}
      <div className='mb-3'>
        <img
          src={toAbsoluteUrl('/media/auth/404-error.png')}
          className='mw-100 mh-300px theme-light-show'
          alt=''
        />
        <img
          src={toAbsoluteUrl('/media/auth/404-error-dark.png')}
          className='mw-100 mh-300px theme-dark-show'
          alt=''
        />
      </div>
      {/* end::Illustration */}

      {/* begin::Link */}
      <div className='mb-0'>
        <Link to={getFirstPermittedRoute()} className='btn btn-sm btn-primary'>
          Return to Permitted Page
        </Link>
      </div>
      {/* end::Link */}
    </>
  )
}

export {Error404}
